"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsrRequestContextSymbol = exports.SsrCacheHintsManagerSymbol = void 0;
exports.SsrCacheHintsManagerSymbol = Symbol('SsrCacheHintsManager');
exports.SsrRequestContextSymbol = Symbol('SsrRequestContextSymbol');
//# sourceMappingURL=cacheHintsManager.js.map